import React from "react"
import { Link } from "gatsby"
import classNames from "classnames"

export default ({ pageContext }) => {
  const prevLink =
    pageContext.currentPage <= 2
      ? `/`
      : `/${pageContext.basePath}/${pageContext.currentPage - 1}`

  return (
    <ul className="slipnote-pagination">
      {pageContext.currentPage > 1 && (
        <li key={`page_prev`}>
          <Link to={prevLink}>Prev</Link>
        </li>
      )}
      {Array.from({ length: pageContext.numPages }).map((item, i) => {
        const index = i + 1
        const link = index === 1 ? "/" : `/${pageContext.basePath}/${index}`
        return (
          <li
            className={classNames({
              "is-active": pageContext.currentPage === index,
            })}
            key={`page_${index}`}
          >
            {pageContext.currentPage === index ? (
              <span>{index}</span>
            ) : (
              <a href={link}>{index}</a>
            )}
          </li>
        )
      })}
      {pageContext.currentPage < pageContext.numPages && (
        <li key={`page_next`}>
          <Link to={`/${pageContext.basePath}/${pageContext.currentPage + 1}`}>
            Next
          </Link>
        </li>
      )}
    </ul>
  )
}
